<template>
  <div class="">
    <div id="complaint">
      <img
        @click="Complaint"
        src="../assets/images/complaint.png"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Complaint",
  props: {},
  data() {
    return {};
  },
  computed: {
    gsphone: function() {
      return this.$store.getters.getGsphoneinfo;
    }
  },
  created() {
    this.getGsphone();
  },
  mounted() {},
  watch: {},
  methods: {
    Complaint() {
      this.$dialog.confirm({
        title: "投诉电话",
        mes: "您确定拨打：" + this.gsphone.complaint,
        opts: () => {
          this.callPhone(this.gsphone.complaint);
        }
      });
    },
    //调用拨号
    callPhone(phoneNumber) {
      window.location.href = "tel:" + phoneNumber;
    },
    getGsphone() {
      this.$ajax({
        method: "post",
        url: "Open/getGsphone",
        data: {}
      })
        .then(response => {
          this.$store.commit("setGsphone", response.data.data);
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  },
  components: {}
};
</script>

<style scoped lang="css">
#complaint {
  clear: both;
  text-align: center;
  position: fixed;
  bottom: 0.5rem;
  left: 3.14rem;
  /* margin-top: 30px; */
}
/* #complaint{text-align: center;padding-top: 0.3rem;} */
#complaint img {
  height: 0.28rem;
  width: 1.23rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Complaint.vue